module.exports = __webpack_public_path__ + "static/media/maki_shrimp.a1a9ad37.webp";